import React, {useEffect} from "react";
import SiteContent from "../components/site-items/SiteContent/SiteContent";
import Navbar from "../parts/Navbar/Navbar";
import Footer from "../parts/Footer/Footer";
import PageWrapper from "../components/page-items/PageWrapper/PageWrapper";
import Logo from "../components/logos/Logo/Logo";
import PageHeader from "../components/page-items/PageHeader/PageHeader";
import PageContent from "../components/page-items/PageContent/PageContent";
import {scrollToTop} from "../helpers/helpersFunctions";
import Menu from "../components/buttons/Menu/Menu";
import Info from "../sections/Info/Info";
import NotFoundContainer from "../sections/NotFound/NotFoundContainer";

const NotFound = () => {

    useEffect(() => {
        scrollToTop();
    }, []);

    return (
        <SiteContent>
            <Navbar/>
            <PageWrapper>
                <PageContent>
                    <PageHeader header={'404'}/>
                    <NotFoundContainer/>
                </PageContent>
                <Logo width={600}
                      height={600}
                      style={{
                          position: 'absolute', right: -160, bottom: -140,
                          opacity: 0.07, transform: 'rotate(12deg)'
                      }}
                />
                <Info/>
            </PageWrapper>
            <Menu/>
            <Footer/>
        </SiteContent>
    );
};

export default NotFound;
